import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateMultiColumn } from '@/js/global/animations'


register("multi-column", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateMultiColumn = animateMultiColumn(this.container);
    }
  },
  onUnload() {
    var _this$animateMultiCol;
    (_this$animateMultiCol = this.animateMultiColumn) === null || _this$animateMultiCol === void 0 ? void 0 : _this$animateMultiCol.destroy();
  }
});
